import { getButtonVariant } from "@/shared/components/LinkButton";
import { BlockButton } from "../directusTypes";
import { ButtonDataType } from "@/shared/types";

export const getButtonLinkData = (
  directusButton: BlockButton
): ButtonDataType => {
  const linkButtonData: ButtonDataType = {
    variant: getButtonVariant(directusButton.variant ?? ""),
    children: directusButton.label ?? "",
    href: "",
  };
  switch (directusButton.type) {
    case "page":
      linkButtonData.href =
        typeof directusButton.page === "object" &&
        directusButton.page?.permalink
          ? directusButton.page.permalink
          : "";
      break;
    case "post":
      linkButtonData.href =
        typeof directusButton.post === "object" && directusButton.post?.slug
          ? `/blog/${directusButton.post.slug}`
          : "";
      break;
    default:
      linkButtonData.href = directusButton.url ?? "";
  }
  return linkButtonData;
};
